import { BreakpointWidth } from '@app/enumerations';
import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		tableCell_container: {
			fontSize: '1rem',
		},
		tableCell_headerCell: {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
		},
    });
});

export default useStyles;
